<div class="users-section" *ngIf="prospectCompanyKey">
    <users
        [isAdmin]="true"
        [clientDashboardExperiences]="clientDashboardExperiences"
        [companyKey]="prospectCompanyKey"
        [isProspectView]="true"
    >
    </users>
</div>
<no-data
    *ngIf="!prospectCompanyKey"
    class="container-fluid page-container no-data-container"
    [titleText]="noCompanyMessage"
></no-data>
